import { useMutation } from '@tanstack/react-query';
import {
  UpdateMerchantCredentialDto,
  MerchantApiCredentialsService,
} from 'services/openapi';

type UpdateMerchantCredentialMutationVariables = UpdateMerchantCredentialDto & {
  id: string;
};

export const useUpdateMerchantCredentialMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, UpdateMerchantCredentialMutationVariables>({
      mutationFn: (variables) => {
        const { id, ...payload } = variables;
        return MerchantApiCredentialsService.merchantApiControllerUpdateClient(
          id,
          payload,
        );
      },
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
